import React from 'react'
import { ElementClicksTag } from './ElementClickTag'

import {
  WebSvg
} from '../../components/Icons'

const SUGGESTION_ELEMENT = 'suggestion'

const RichCard = ({ imageUrl, title, description, buttons, cardIndex, onNavigateToStep }) => {
  return (
    <div className="w-full max-w-sm">
      <div className="flex flex-col border-2 border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
        <div className="relative">
          <img
            style={{ aspectRatio: '4/3' }}
            className="object-cover w-full"
            src={imageUrl}
            alt={title || 'Card image'}
          />
        </div>
        <div className="p-4 flex flex-col">
          {title && (
            <p className="font-semibold text-base mb-2 text-gray-900 line-clamp-2">{title}</p>
          )}
          {description && (
            <p className="font-light text-sm text-gray-600 line-clamp-2 mb-3">
              {description}
            </p>
          )}
          {buttons && buttons.length > 0 && (
            <div className="space-y-2 mt-auto">
              {buttons.map((button, idx) => {
                const buttonData = {
                  text: button.text || button.displayText || '',
                  clicks: button.clicks || 0,
                  postback: button.postback,
                  openUrl: button.openUrl,
                  type: button.type
                }
                
                if (!buttonData.text && buttonData.postback) {
                  const postbackParts = buttonData.postback.split('-')
                  if (postbackParts.length > 1) {
                    const meaningfulParts = postbackParts.slice(1).filter(part => 
                      part && !part.match(/^\d+\/\d+$/) && !part.includes('parent')
                    )
                    if (meaningfulParts.length > 0) {
                      buttonData.text = meaningfulParts.join(' ').replace(/_/g, ' ').trim()
                    }
                  }
                }
                
                if (!buttonData.text) return null
                
                return (
                  <ElementClicksTag
                    key={idx}
                    elementInfo={{ ...buttonData, isCarouselCard: true }}
                    elementType="button"
                    onClick={onNavigateToStep}
                  />
                )
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const renderCards = (cards, onNavigateToStep) => {
  if (!cards || !Array.isArray(cards) || cards.length === 0) {
    return null
  }
  
  return cards.map((cardInfo, index) => {
    return (
      <RichCard
        key={index}
        imageUrl={cardInfo.image || cardInfo.imageUrl}
        title={cardInfo.title}
        description={cardInfo.description || cardInfo.subtitle}
        buttons={cardInfo.buttons || []}
        cardIndex={index}
        onNavigateToStep={onNavigateToStep}
      />
    )
  })
}

export const CarouselStats = ({ elementInfo, onNavigateToStep }) => {
  return (
    <div className="w-full">
      
      {/* Suggestions/Options */}
      {elementInfo.suggestions && elementInfo.suggestions.length > 0 && (
        <section id="suggestionsList" className="mb-6">
          <h3 className="text-sm font-semibold text-gray-700 mb-3">Response Options:</h3>
          <div className="flex flex-col gap-3">
            {elementInfo.suggestions.map((suggestion, index) => {
              // Extract text and postback from suggestion
              const suggestionData = {
                text: suggestion.text || suggestion.displayText || '',
                clicks: suggestion.clicks || 0,
                postback: suggestion.postback,
                openUrl: suggestion.openUrl,
                type: suggestion.type
              }
              
              if (!suggestionData.text && suggestionData.postback) {
                const postbackParts = suggestionData.postback.split('-')
                if (postbackParts.length > 1) {
                  const meaningfulParts = postbackParts.slice(1).filter(part => 
                    part && !part.match(/^\d+\/\d+$/) && !part.includes('parent')
                  )
                  if (meaningfulParts.length > 0) {
                    suggestionData.text = meaningfulParts.join(' ').replace(/_/g, ' ').trim()
                  }
                }
              }
              
              if (!suggestionData.text) return null
              
              return (
                <ElementClicksTag
                  key={index}
                  elementInfo={suggestionData}
                  elementType={SUGGESTION_ELEMENT}
                  onClick={onNavigateToStep}
                />
              )
            })}
          </div>
        </section>
      )}
      
      {/* Cards Grid */}
      {elementInfo.cards && elementInfo.cards.length > 0 && (
        <section id="CardsList" className="mt-6">
          <h3 className="text-sm font-semibold text-gray-700 mb-4">Carousel Cards:</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {renderCards(elementInfo.cards, onNavigateToStep)}
          </div>
        </section>
      )}
    </div>
  )
}
